import { render, staticRenderFns } from "./order-info.vue?vue&type=template&id=efcc543e&scoped=true&"
import script from "./order-info.vue?vue&type=script&lang=js&"
export * from "./order-info.vue?vue&type=script&lang=js&"
import style0 from "./order-info.vue?vue&type=style&index=0&id=efcc543e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcc543e",
  null
  
)

export default component.exports